import {
  Column,
  CreateDateColumn,
  DeleteDateColumn,
  PrimaryGeneratedColumn,
  ManyToOne,
  Entity
} from 'typeorm';
import Promocao from './Promocao';
import Tamanho from './Tamanho';

@Entity()
export class PrecoPromocional {
  @PrimaryGeneratedColumn()
  id!: number;

  @Column()
  preco: number = 0;

  @ManyToOne(() => Promocao)
  promocao!: Promocao;

  @ManyToOne(() => Tamanho, { onDelete: 'CASCADE' })
  tamanho!: Tamanho;

  @CreateDateColumn({ select: false })
  createdAt!: Date;

  @DeleteDateColumn({ select: false })
  deletedAt!: Date;
}

export default PrecoPromocional;
